import CryptoJS from "crypto-js";
import { getConfig } from './config';

const keyProvider = () => {
    try {
        return getConfig().cryptoJsKey;
    } catch (error) {
        // Runtime config not loaded yet - this should be handled gracefully by callers
        throw new Error('Runtime config not loaded. Call loadRuntimeConfig() first.');
    }
};

export const encrypt = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), keyProvider()).toString();
}

const IsJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const decrypt = (data) => {
    if (!data) return false;
    const bytes = CryptoJS.AES.decrypt(data, keyProvider());
    const utf8 = bytes.toString(CryptoJS.enc.Utf8);
    return IsJsonString(utf8) ? JSON.parse(utf8) : false;
}